module.exports = __webpack_public_path__ + "static/media/favicon.a5454589.png";